import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "option"];
import FormattedMessage from 'I18n/components/FormattedMessage';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import { ApiNameToProductTranslationKeyMap } from '../../constants/ApiNameToProductTranslationKeyMap';
import { jsx as _jsx } from "react/jsx-runtime";
const CompareSelectItem = _ref => {
  let {
      children,
      option
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx("span", Object.assign({}, rest, {
    children: /*#__PURE__*/_jsx(UITooltip, {
      placement: "right",
      title: option.value && /*#__PURE__*/_jsx(FormattedMessage, {
        message: ApiNameToProductTranslationKeyMap[option.value]
      }),
      disabled: option.disabled,
      children: children
    })
  }));
};
export default CompareSelectItem;